/** @jsx jsx */
import { jsx } from '@emotion/react';

import ComplexSpotlightCollectionComponent from 'bundles/page-config-common/components/shared/complex-spotlight-collection/ComplexSpotlightCollectionComponent';
import { toPathway } from 'bundles/page-config-common/components/shared/complex-spotlight-collection/toPathway';
import type {
  SpotlightCollectionRecommendationCollection,
  SpotlightCollectionWithSecondaryCta,
} from 'bundles/page-config-common/types/spotlight-collection';

type Props = {
  showSingleCardDisplay: boolean;
  recommendationCollection: SpotlightCollectionWithSecondaryCta;
  recommendationCollections: SpotlightCollectionRecommendationCollection[];
  twoColumnLayout?: boolean;
};

const ComplexSpotlightCollectionModuleRenderer = (props: Props) => {
  const { showSingleCardDisplay, recommendationCollection, recommendationCollections, twoColumnLayout } = props;

  if (!recommendationCollection.firstFilter) {
    return null;
  }

  const firstFilterElements = recommendationCollection.firstFilter.elements?.[0];

  if (firstFilterElements?.__typename !== 'Recommendation_Collection') {
    return null;
  }

  if (!firstFilterElements) {
    return null;
  }

  const pathway = toPathway(firstFilterElements);

  const filters = recommendationCollections.map((rec) => ({
    id: rec.filterDescription,
    label: rec.filterDescription,
    queryContext: {
      queryCollectionId: rec.id,
      additionalInput: rec.additionalInput,
    },
  }));

  return (
    <ComplexSpotlightCollectionComponent
      filters={filters}
      initialPathway={pathway}
      recommendationCollection={recommendationCollection}
      showSingleCardDisplay={showSingleCardDisplay}
      twoColumnLayout={twoColumnLayout}
    />
  );
};

export default ComplexSpotlightCollectionModuleRenderer;
